<template>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <div
      class="d-flex flex-column justify-content-center align-items-center w-100"
    >
      <div class="video-container ms-2">
        <div class="header-text">Introducing SimpleLoyalty</div>
        <!-- <iframe
          src="https://www.youtube.com/embed/WykDPBvoyx8"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          width="100%"
          height="315"
        ></iframe> -->
        <div class="col-12 d-flex flex-column">
          <p class="fw-bold fs-5 mb-0">
            Here are the credentials to your loyalty program
          </p>
          <p>Check out the short video introduction above to know more!</p>
        </div>
      </div>
    </div>

    <SuccessPoints step="1">
      <template #title>
        <span class="fw-bold d-flex align-items-center">
          <img
            :src="StoreIcon"
            alt="Store Icon"
            style="width: 25px"
            class="me-2"
          />
          Store (For Cashiers & Operations Staff)
        </span>
      </template>

      <template #left>
        <p>
          • Approach customers to collect points by just keying in their phone
          <span>number when paying the bill.</span>
        </p>
        <QrcodeVue :value="storeUrlWithParams" :size="150" />
        <br />
        <a :href="storeUrlWithParams" target="_blank" style="color: red">
          {{ storeUrl }}
        </a>

        <div class="card mt-3 w-75">
          <div class="card-body">
            <p class="fw-bold">Login Details</p>
            <div
              v-for="outlet in store.createdBrand.outletCredentials"
              :key="outlet"
            >
              <p class="mb-0 fw-bold">{{ outlet.storeName }}</p>
              <p class="mb-0 fw-bold">
                Store ID: <span class="fw-normal">{{ outlet.id }}</span>
              </p>
              <p class="mb-0 fw-bold">
                Store Password:
                <span class="fw-normal">{{ outlet.password }}</span>
              </p>
            </div>
          </div>
        </div>
      </template>

      <template #right>
        <img
          style="width: 200px"
          src="@/assets/gif/STORE.webp"
          class="gif-container"
        />
      </template>
    </SuccessPoints>

    <SuccessPoints step="2">
      <template #title>
        <span class="fs-5 fw-bold d-flex align-items-center">
          <img
            :src="DashboardIcon"
            alt="Dashboard Icon"
            style="width: 25px"
            class="me-2"
          />
          Dashboard (For Business Owners & Marketers)
        </span>
      </template>

      <template #left>
        <FlexCol class="gap-1">
          <span>• Send automated message reminders</span>
          <span>• Create and track marketing campaigns</span>
          <span>• Set up your loyalty program</span>
          <a
            class="mt-3"
            :href="dashboardUrlLogin"
            target="_blank"
            style="color: red"
          >
            {{ dashboardUrlLogin }}
          </a>
        </FlexCol>
        <div class="card mt-3">
          <div class="card-body">
            <p class="fw-bold">Login Details</p>
            <p class="mb-0 fw-bold">
              Email: <span class="fw-normal">{{ dashboardEmail }}</span>
            </p>
            <FlexRow>
              <a
                class="text-decoration-underline fw-bold"
                style="color: black"
                :href="resetPasswordRedirect"
              >
                Reset Password
              </a>
            </FlexRow>
          </div>
        </div>
      </template>

      <template #right>
        <img
          src="@/assets/gif/DASHBOARD.webp"
          class="gif-container"
          style="max-width: 350px; min-width: 350px"
        />
      </template>
    </SuccessPoints>

    <SuccessPoints step="3">
      <template #title>
        <span class="fs-5 fw-bold d-flex align-items-center">
          <img
            :src="MembersIcon"
            alt="Members Icon"
            style="width: 25px"
            class="me-2"
          />
          Member's Portal (For Customers)
        </span>
      </template>

      <template #left>
        <p class="mb-1">• Check points and rewards available to be redeemed</p>
        <a :href="slAppWithBrandSlug" target="_blank" style="color: red">
          {{ slAppWithBrandSlug }}
        </a>
        <div class="card mt-3 w-75 mb-5">
          <div class="card-body">
            <p>
              Customers only need to key in & verify their phone number to log
              in!
            </p>
          </div>
        </div>
      </template>
      <template #right>
        <img
          src="@/assets/gif/MEMBERS.webp"
          class="gif-container"
          style="width: 200px"
        />
      </template>
    </SuccessPoints>

    <div class="row mt-5 gx-1">
      <div class="col">
        <div class="button-container">
          <button
            class="btn btn-primary w-100"
            type="submit"
            @click="redirectToDashboard"
          >
            Continue to dashboard
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import FlexRow from "@/layout/FlexRow.vue";
import QrcodeVue from "qrcode.vue";
import NewBrandNavigation from "@/pages/reusables/navigation/NewBrandNavigation.vue";
import { ref, computed, watch } from "vue";
import { useBrandSetupStore } from "@/stores/brand";
import { useRouter } from "vue-router";
import { useMutation, useQuery } from "@urql/vue";
import cookie from "@/utilities/cookie.js";
import { SET_ACTIVE_BRAND, GET_BRAND_SLUG } from "@/constants/graphql";
import StoreIcon from "@/assets/ICO54.svg";
import DashboardIcon from "@/assets/ICO92.svg";
import MembersIcon from "@/assets/ICO22.svg";
import SuccessPoints from "./Components/SuccessPoints.vue";
import FlexCol from "@/layout/FlexCol.vue";

const store = useBrandSetupStore();
const router = useRouter();
const { executeMutation: setActiveBrandMutation } =
  useMutation(SET_ACTIVE_BRAND);

const storeUrl = ref(process.env.VUE_APP_STORE_URL);
const storeUrlWithParams = ref(
  `${process.env.VUE_APP_STORE_URL}/#/sign-in?registered=1`
);
const dashboardUrl = ref(process.env.VUE_APP_DASHBOARD_URL);
const appUrl = ref(process.env.VUE_APP_CHECKPOINTS_URL);
const link = ref();

const brandSlugQuery = useQuery({
  query: GET_BRAND_SLUG,
  variables: {
    brandId: store.createdBrand.brandId,
  },
});

const slAppWithBrandSlug = computed(() => {
  if (link.value) return link.value;
  return `${appUrl.value}`;
});

const dashboardUrlLogin = computed(() => `${dashboardUrl.value}/#/login`);
const resetPasswordRedirect = computed(
  () => `https://dashboard.simpleloyalty.com/#/auth-reset`
);
const dashboardEmail = computed(() => cookie.getSecureCookie("mulah_em") || "");

function processBrandSlug(newData) {
  let slug = null;
  if (newData && newData.slBrand) {
    slug = newData.slBrand.slug;
    link.value = "https://app.simpleloyalty.com/#/" + slug;
  } else if (newData) {
    console.error("Error:", newData.error);
  }
}

watch(brandSlugQuery.data, processBrandSlug);

function redirectToDashboard() {
  if (cookie.getSecureCookie("mulah_br_id") === false) {
    setActiveBrandMutation({
      brandId: store.newBrandId,
    })
      .then((result) => {
        if (result.data.setActiveBrand.errors.length > 0) {
          alert("An error occurred when setting the active brand.");
        } else {
          cookie.setSecureCookie("mulah_br_id", store.newBrandId, false, true);
          cookie.setSecureCookie(
            "mulah_br",
            result.data.setActiveBrand.name,
            false,
            true
          );
          router.push({
            name: "Dashboard",
          });
        }
      })
      .catch((error) => {
        alert("Failed to update active brand");
      });
  }
  store.reset();
  router.push({
    name: "Dashboard",
  });
}
</script>

<style scoped>
.bullet-point {
  position: relative;
  padding-left: 1.5rem;
  text-indent: -1rem;
}

.video-container {
  width: 100%;
  max-width: 800px;
  margin-top: 20px;
}

:deep(.video-container iframe) {
  border-radius: 15px;
}

.header-text {
  color: black;
  font-weight: bold;
  text-align: center;
  font-size: 20px;
  margin-bottom: 50px;
}

.gif-container {
  width: 100%;
  max-width: 200px;
  height: auto;
  border: 2px solid #000;
  border-radius: 10px;
}

@media (max-width: 576px) {
  .w-75 {
    width: 90vw;
  }
  .gif-container {
    max-width: 150px;
  }
}

@media (min-width: 768px) {
  .w-75 {
    width: 60vw;
  }
}

@media (min-width: 992px) {
  .w-75 {
    width: 40vw;
  }
}

.NewBrandNavigation {
  margin-left: -40px;
}
</style>
